import { SVGFC } from '@repo/toolkit/types'

const AddUserIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.7297 5.09082C8.86271 5.09082 7.3355 6.61913 7.3355 8.48614C7.3355 9.62774 7.90819 10.6387 8.77884 11.2537C6.75215 12.0662 5.31463 14.0484 5.31463 16.3607C5.29845 17.0897 6.40025 17.0897 6.38407 16.3607C6.38407 13.9063 8.36305 11.9284 10.8175 11.9284C11.6742 11.9284 12.4695 12.1726 13.1464 12.5915C13.755 12.9647 14.3147 12.052 13.7062 11.6788C13.4014 11.4902 13.0712 11.3432 12.7308 11.2161C13.5712 10.5979 14.1208 9.60505 14.1208 8.48614C14.1208 6.61913 12.5968 5.09082 10.7297 5.09082ZM10.7297 6.16133C12.0188 6.16133 13.0514 7.19709 13.0514 8.48614C13.0514 9.7752 12.0188 10.8067 10.7297 10.8067C9.44069 10.8067 8.40495 9.7752 8.40495 8.48614C8.40495 7.19709 9.44069 6.16133 10.7297 6.16133ZM14.0101 15.2599V16.3294C14.0256 17.0267 15.0641 17.0267 15.0796 16.3294V15.2599H16.1501C16.8637 15.2599 16.8637 14.1895 16.1501 14.1895H15.0796V13.12C15.0831 12.8202 14.8394 12.5761 14.5396 12.579C14.2439 12.581 14.0067 12.8243 14.0101 13.12V14.1895H12.9151C12.1759 14.2237 12.227 15.2941 12.9407 15.2599H14.0101Z"
        fill={color}
      />
    </svg>
  )
}

export default AddUserIcon
